import * as React from "react";
import styled from "styled-components";
import { Colors } from "../theme/colors";
import { Gallery } from "./gallery";
const Grid = styled.div.withConfig({ displayName: "Grid", componentId: "sc-8zo44t" }) `
    display: grid;
    grid-gap: 30px;
    
    justify-content: center;

    grid-template-columns: repeat(1, 1fr);

    @media (min-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 992px) {
        grid-template-columns: repeat(3, 1fr);
    }
`;
const Item = styled.div.withConfig({ displayName: "Item", componentId: "sc-1u4s4b3" }) `
`;
const H2 = styled.h2.withConfig({ displayName: "H2", componentId: "sc-ubpwrj" }) `
    margin-top: 2em;

    font-size: 15px;
    text-align: center;
    text-transform: uppercase;

    ::after {
        content: "";
        display: block;
        width: 35px;
        margin: 1em auto;

        border: solid 1px ${Colors.ACCENT};
    }
`;
const P = styled.p.withConfig({ displayName: "P", componentId: "sc-1eas4h7" }) `
    color:  ${Colors.FG_2};

    text-align: center;
    line-height: 1.5em;
`;
export const Masonry = (props) => {
    return (React.createElement(Grid, null, props.items.map((item, index) => (React.createElement(Item, { key: index },
        React.createElement(Gallery, { items: item.images }),
        React.createElement(H2, null, item.title),
        React.createElement(P, null, item.description))))));
};
